var _path, _path2, _circle, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHandDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.004 61.694l3.62-3.801h26.603l11.764-28.594c-1.45-6.388-3.854-6.845-8.687-3.258l-11.22 15.383M23.317 74L3.771 54.273l12.307-7.42 15.745 15.202L23.317 74z",
    stroke: "#2E5ECC",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 46.853c6.078-7.306 10.478-9.152 21.174-5.972H53.36c3.35 3.223 2.773 5.103 0 8.506H43.043",
    stroke: "#2E5ECC",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.062,
    cy: 17.65,
    r: 14.65,
    stroke: "#2E5ECC",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.662 12.462c-.648 0-1.152.138-1.512.414-.348.264-.522.714-.522 1.35 0 .288.06.534.18.738.12.204.27.378.45.522.192.144.408.264.648.36.252.084.504.156.756.216v-3.6zm-2.304 7.632c-.012.792.162 1.416.522 1.872.36.456.954.696 1.782.72V18.33a17.475 17.475 0 01-1.476-.468 6.03 6.03 0 01-1.314-.72 3.524 3.524 0 01-.936-1.116c-.24-.444-.36-.996-.36-1.656 0-.576.108-1.08.324-1.512.228-.444.528-.81.9-1.098.384-.3.822-.528 1.314-.684a5.091 5.091 0 011.548-.234V9.438h.774v1.404c.54 0 1.05.072 1.53.216a3.5 3.5 0 011.242.648c.36.288.642.654.846 1.098.216.444.324.96.324 1.548h-2.052c-.024-.612-.186-1.08-.486-1.404-.288-.324-.756-.486-1.404-.486v3.798c.54.144 1.068.312 1.584.504s.972.438 1.368.738c.396.3.714.672.954 1.116.24.444.36.99.36 1.638 0 .672-.114 1.26-.342 1.764a3.488 3.488 0 01-.9 1.242c-.384.324-.834.57-1.35.738a5.755 5.755 0 01-1.674.306v1.404h-.774v-1.404A5.6 5.6 0 0136.88 24a4.063 4.063 0 01-1.386-.81 3.77 3.77 0 01-.9-1.314c-.204-.516-.3-1.11-.288-1.782h2.052zm3.078 2.592c.648-.048 1.176-.234 1.584-.558.42-.336.63-.864.63-1.584 0-.336-.066-.618-.198-.846a1.654 1.654 0 00-.504-.576 2.621 2.621 0 00-.702-.378 9.063 9.063 0 00-.81-.252v4.194z",
    fill: "#2E5ECC"
  })));
}

export default SvgHandDollar;